import Vue from "vue";

const mobileEllipsis = mobile => {
  var result = mobile;
  if (mobile && mobile.length > 11) {
    result = '--'
  }
  return result;
} 
const variableList =  [
  {
    key: '#CustomerName#',
    value: '#消费者昵称#'
  },
  {
    key: '#CommentLink#',
    value: '#评价链接#'
  },
  {
    key: '#CSContact#',
    value: '#客服昵称#'
  },
  {
    key: '#ActivityName#',
    value: '#活动名称#'
  },
  {
    key: '#WareTitle#',
    value: '#商品名称#'
  },
  {
    key: '#PayLink#',
    value: '#付款链接#'
  },
  {
    key: '#OrderId#',
    value: '#订单编号#'
  },
  {
    key: '#Logistics#',
    value: '#物流#'
  },
  {
    key: '#LogisticsNumber#',
    value: '#物流单号#'
  },
  {
    key: '#ShopName#',
    value: '#店铺名称#'
  },
  {
    key: '#OrderContent#',
    value: '#订单内容#'
  },
  {
    key: '#ShopLink#',
    value: '#店铺连接#'
  },
  {
    key: '#CouponLink#',
    value: '#领券链接#'
  },
  {
    key: '#OrderTime#',
    value: '#下单时间#'
  },
  {
    key: '#OrderAmount#',
    value: '#订单金额#'
  },
  {
    key: '#Freight Cost#',
    value: '#邮费#'
  },
  {
    key: '#itemlink#',
    value: '#商品链接#'
  },
  {
    key: '#LandingPage#',
    value: '#自定义链接#'
  }
];
// 英文变量转中文
const enVToChinese =  variableStr => {
  if (variableStr) {
    variableList.forEach(item => {
      if (variableStr.indexOf(item.key) != '-1') {
        var reg = new RegExp(item.key, "g")
        variableStr = variableStr.replace(reg, item.value)
      }
    })
  }
 
  return variableStr;
}
// 中文变量转英文
const ChineseVToEn =  variableStr => {
  if (variableStr) {
    variableList.forEach(item => {
      if (variableStr.indexOf(item.value) != '-1') {
        var reg = new RegExp(item.value, "g")
        variableStr = variableStr.replace(reg, item.key)
      }
    })
  }

  return variableStr;
}
// 英文转中文后的字数长度
const enVToChineseLength = variableStr => {
  var length = 0;
  if (variableStr) {
    length = Vue.prototype.$linkConvertNum(enVToChinese(variableStr));
  }
  return length
}

export default {
  mobileEllipsis,
  enVToChinese,
  ChineseVToEn,
  enVToChineseLength
}
